import { Box, Checkbox, Stack, Typography } from "@mui/material"

export function ApplyTailoringToSchedulesDialogRow({ schedule, selectedPaths, onToggle, last }) {
    const checked = selectedPaths.includes(schedule.schedulePath)

    return (
        <Box
            onClick={toggle}
            onKeyDown={toggleWithKeyboard}
            role="button"
            tabIndex={0}
            data-cy="apply-tailoring-schedule-target"
            sx={{
                display: "block",
                width: 1,
                border: 0,
                borderBottom: last ? 0 : 1,
                borderColor: "divider",
                bgcolor: "background.paper",
                color: "text.primary",
                cursor: "pointer",
                textAlign: "left",
                px: 1.5,
                py: 1.25,
                "&:hover": {
                    bgcolor: "action.hover",
                },
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <Checkbox checked={checked} tabIndex={-1} sx={{ p: 0.25 }} />
                <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                    <Typography variant="subtitle2" sx={{ lineHeight: 1.3 }}>
                        {schedule.title}
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                        <Typography variant="caption" color="primary.main">
                            {schedule.code}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {schedule.location || "Regime root"}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Box>
    )

    function toggle() {
        onToggle(schedule.schedulePath)
    }

    function toggleWithKeyboard(event) {
        if (event.key !== "Enter" && event.key !== " ") return
        event.preventDefault()
        toggle()
    }
}
